<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  beforeCreate() {
    // this.$store.commit("saveOrgInfo",JSON.stringify({ Id:"", OrgId:"e3414dffe08b4167925cb5bf44e5ef1c", Domain:"http://bbb.51zhaoshu.vip"}));
    let orgInfo = window.localStorage.OrgInfo ? JSON.parse(window.localStorage.OrgInfo) : undefined;
    let domain = "";
    if (orgInfo) {
      domain = orgInfo.Domain.replace("https://", "");
      domain = domain.replace("http://", "");
      domain = domain.replace("/", "").trim();
    }
    if (document.domain == domain) {
      console.log("该域名已经缓存，不需要重新加载");
      let url = this.$bti.GetOrgInfoFromDomain(null, true);
      this.http.postParam(url, { "domain": document.domain }).then((r) => {
        //if (r.data.Id === '999999') {
        if (window.localStorage.Token && window.localStorage.Token.length >= 128) {
          console.log('用户已登录..')
          this.$reslove("绑定成功");
        } else {
          if (r.data.AllowLogon) {
            var url = this.$bti.GetJwtoken(null, true);
            var params = {
              phone: '13400000001',
              pass: '123456',
            };
            this.http.postParam(url, params).then((res) => {
              this.$store.commit("saveToken", res.token);
              this.$reslove("绑定成功");
            })
          } else {
            this.$reslove("绑定成功");
            //不在IP范围内
            console.log('不在IP范围内')
            this.$router.push({ path: '/empty', query: { ip: r.data.AccessIP } });
          }
        }
      })
    } else {
      let url = this.$bti.GetOrgInfoFromDomain(null, true);
      this.http.postParam(url, { "domain": document.domain }, "正在根据域名获取机构信息....").then((r) => {
        if (r.code != 1) {
          this.$message.error(r.info);
        } else {
          if (r.data == null) {
            this.$message.error("该域名没有绑定学校，请检查输入。");
            return this.$router.push({ name: 'error' })
          } else {
            console.log("域名信息已缓存");
            //if (r.data.Id === '999999') {
            if (window.localStorage.Token && window.localStorage.Token.length >= 128) {
              console.log('用户已登录..')
              this.$reslove("绑定成功");
            } else {
              if (r.data.AllowLogon) {
                var url = this.$bti.GetJwtoken(null, true);
                var params = {
                  phone: '13400000001',
                  pass: '123456',
                };
                this.http.postParam(url, params).then((res) => {
                  this.$store.commit("saveToken", res.token);
                  this.$store.commit("saveOrgInfo", JSON.stringify(r.data));
                  this.$reslove();
                })
              } else {
                this.$store.commit("saveOrgInfo", JSON.stringify(r.data));
                this.$reslove();
                //不在IP范围内
                console.log('不在IP范围内')
                this.$router.push({ path: '/empty', query: { ip: r.data.AccessIP } });
              }
            }
          }
        }
      });
    }
  }
}
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// src/App.vue